import { MutableRefObject } from "react"

export function focusInput(input: MutableRefObject<HTMLInputElement | null>) {
    if (!input?.current) return false
    input.current.focus()
    return true
}
